import React from 'react';
import { Button } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { ReCaptcha } from 'react-recaptcha-v3';
import dataAPI from '../../Utilities/dataAPI';

const styles = theme => ({
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
    },
});

let tryPaying = false;

class PayButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            captchaCompleted: false,
            recaptchaToken: "",
            // recaptchaVersion: "WaiverInvite|0.0.0",
        }
    }

    ///////////////////////BEGINNING OF RECAPTCHA
    reloadCaptcha = () => {
        this.recaptcha.execute();
        this.forceUpdate();
    }

    onCaptchaResponse = (response) => {
        //captcha completed, we may proceed to use it here on
        this.completeCaptcha(response);
    }

    updateReCaptcha = (recaptchaToken) => {
        this.setState({
            recaptchaToken: recaptchaToken,
        })
    }

    //this function get called once recaptcha gets response (ie token)
    completeCaptcha = (response) => {
        this.updateReCaptcha(response);

        if (tryPaying) {
            //next step: get web concession endpoint to get concession_cart_id
            this.getWebConcession(response);
            tryPaying = false;
        }

    }
    /////////////////////////////////////END OF RECAPTCHA

    getWebConcession = async (recaptcha) => {

        const concessionInfo = this.getConcessionInfo();
        const orderList = this.props.order;
        //quantity is static number for now.... can update it to be per "orderItem" in api function.....
        //const quantity = orderList.reduce((total, orderItem) => total += Number(orderItem.quantity), 0);
        const isShipping = (this.props.deliveryOption === 'outsideStore') ? true : false;

        try {
            let webConcessionResult = await dataAPI
                .holdWebConcessions(
                    this.props.firstName,
                    this.props.lastName,
                    this.props.email,
                    this.props.phone,
                    concessionInfo.location_id,
                    concessionInfo.concession_id,
                    orderList,
                    this.props.shippingInfo,
                    isShipping,
                    recaptcha
                )
            return webConcessionResult;
        }
        catch (error) {
            console.log(error);
        }
    }

    getConcessionInfo = () => {
        let concessionInfo = this.props.concessionData.filter(concession => Number(concession.location_id) === this.props.shipLocation);
        return concessionInfo[0];
    }

    handleSubmission = () => {
        //set switch to trigger api calls to true
        tryPaying = true;

        //reload recaptcha - once that's set you can proceed with api call
        this.reloadCaptcha();
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={'Pay'}>
                {/* {!this.state.loading && sessionToken && purchaseCode ? '' :     */}
                <Button
                    // disabled={!this.props.recaptcha}
                    // onClick={e => {this.props.dbSubmit({
                    //     ssl_txn_auth_token: sessionToken, 
                    //     ssl_invoice_number: purchaseCode, 
                    //     ssl_email: emailAddress, 
                    //     ssl_first_name: firstName, 
                    //     ssl_last_name: lastName
                    // })}}
                    onClick={this.handleSubmission}
                    value="Pay"
                    name="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                >
                    Pay
            </Button>
                <ReCaptcha
                    sitekey='6LeteZcUAAAAAPs85lUcjCBGeN0ZjKjuPilwNIO-'
                    verifyCallback={this.onCaptchaResponse}
                    ref={ref => this.recaptcha = ref}
                />
            </div>
        )
    }
}

PayButton.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PayButton);